import React from "react";
import '../../css/popup.css'

const Popup = ({message, onClose}) => {
    return (
        <div className="popup-overlay">
            <div className="popup-content tw-mx-auto tw-m-6">
                <button className="popup-close" onClick={onClose}>
                    &times;
                </button>
                {message === 1 && (
                    <div className="tw-flex tw-flex-col tw-gap-1 richtext">
                        <h3 className="tw-text-h3">Rubrique Conseil :</h3>
                        <p>En choisissant cette option <strong>Couverture obligatoire de vos Salariés et
                            facultative de leurs ayants droit</strong>, votre entreprise sera amenée : </p>
                        <ul>
                            <li>A cofinancer à hauteur de 50% minimum la
                                cotisation de vos seuls salariés
                            </li>
                            <li>A proposer aux ayants droit de vos
                                salariés (conjoints, enfants…) de rejoindre s’ils le souhaitent le contrat. Votre
                                entreprise n’est pas tenue de participer à la cotisation des ayants droit. Si elle le
                                fait, cette prise en charge est intégralement assujettie à charges sociales.
                            </li>
                        </ul>
                        <p>Cf. fiches pratiques</p>
                        <p><strong>Attention</strong> : Vous ne devez déclarer que le nombre de salariés cadres et non
                            cadres à inscrire au contrat
                            obligatoire. <strong>Les salariés bénéficiant
                                d’une clause de dispense ne doivent pas être comptabilisés.</strong>
                        </p>
                    </div>
                )}
                {message === 2 && (
                    <div className="tw-flex tw-flex-col tw-gap-1 richtext">
                        <h3>Rubrique Conseil :</h3>
                        <p>En choisissant cette option <strong>Couverture obligatoire de vos Salariés et de
                            leurs ayants droit</strong>, votre entreprise sera amenée à cofinancer à hauteur de 50%
                            minimum
                            la cotisation de vos salariés ainsi que celle de leurs ayants droit (conjoints, enfants…).
                            Sauf
                            dispenses d’adhésion introduites dans les conditions prévues à l’article D.911-3 du Code de
                            la
                            sécurité sociale, vos salariés devront obligatoirement inscrire tous leurs ayants droit au
                            contrat.</p>
                        <p>Cf. fiches pratiques</p>
                        <p><strong>Attention</strong> : Vous ne devez déclarer que
                            le nombre de salariés cadres et non cadres à inscrire au contrat obligatoire. <strong>Les
                                salariés bénéficiant d’une clause de
                                dispense ne doivent pas être comptabilisés.</strong>
                        </p>
                    </div>
                )}
                {message === 3 && (
                    <div className="tw-flex tw-flex-col tw-gap-1 richtext">
                        <h3>Contrat Socle Obligatoire :</h3>
                        <p>Le Contrat Socle obligatoire répond aux contraintes de mise en place d’une mutuelle
                            obligatoire. Le coût de ce contrat socle doit être pris en charge pour moitié minimum par
                            l’entreprise.</p>
                        <p>Tous les salariés sauf cas particuliers doivent y adhérer (voir <a href="/fiches-pratiques">fiche
                            pratique numéro 2</a>).</p>
                        <p>Ce contrat socle doit respecter des minimas et maximas de garantie (voir <a
                            href="/fiches-pratiques">fiche pratique numéro 3</a>).
                        </p><p>Vous pouvez
                        déterminer le niveau de garantie souhaité en déplaçant les curseurs bleus vers la droite pour
                        améliorer la couverture ou vers la gauche pour la réduire.</p><p>Il ne peut y avoir plus de 3
                        niveaux d’écart entre les différents modules de soins.</p></div>
                )}
                {message === 4 && (
                    <div className="tw-flex tw-flex-col tw-gap-1 richtext">
                        <h3>Renfort Facultatif:</h3>
                        <div><p>Le renfort facultatif est un contrat distinct du Contrat Socle Obligatoire dont
                            l’objectif est
                            de permettre aux salariés qui le souhaitent de renforcer leur couverture santé. Les
                            salariés n’ont aucune obligation à adhérer à ce renfort facultatif. S’ils choisissent
                            d’y souscrire, le coût est intégralement à leur charge.</p>
                            <p>Le renfort facultatif doit être
                                au minimum de 1 niveau supplémentaire de couverture par rapport au Contrat Socle
                                Obligatoire
                                pour chaque module de soins et ne peut s’écarter de plus de 3 niveaux du Contrat
                                Socle.<br/>Enfin,
                                il ne peut y avoir plus de 3 niveaux d’écart entre les différents modules de soins du
                                Renfort facultatif.</p><p>Vous pouvez déterminer le niveau de garantie souhaité du
                                Renfort
                                facultatif en déplaçant les curseurs verts vers la droite pour améliorer la couverture
                                ou
                                vers la gauche pour la réduire.</p>
                        </div>
                    </div>
                )}
                <div className="tw-flex tw-mx-auto tw-justify-center tw-mt-4">
                    <button onClick={onClose} type="button" className="tw-w-[342px] btn btn-primary tw-self-stretch">OK</button>
                </div>
            </div>
        </div>
    );
};

export default Popup;